var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop } from 'vue-property-decorator';
import EditableTextarea from '@/components/EditableTextarea/EditableTextarea.vue';
import AQuillEditor, { AQuillEditorActionsEnum } from '@/components/AQuillEditor/AQuillEditor.vue';
import { Group } from '@/models/Group';
import { GoalPlannerNote, GoalPlannerNoteRecurrence, } from '@/models/GoalPlannerNote';
import ErrorHandler from '@/support/ErrorHandler';
import { formattedDate } from '@/support/Date';
import i18n from '@/i18n';
import { getWeekDays } from '@/items/Days';
let ManageGoalPlannerNoteDialog = class ManageGoalPlannerNoteDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.AQuillEditorActionsEnum = AQuillEditorActionsEnum;
        this.note = new GoalPlannerNote({
            group_id: this.group.id,
            recurrence: GoalPlannerNoteRecurrence.NONE,
        });
        this.days = getWeekDays();
        this.selectedDays = [];
        this.isRepeat = false;
        this.editorContent = '';
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        if (this.existingNote) {
            this.note = this.existingNote;
            this.editorContent = this.note.note;
            if (this.existingNote.recurrence !== GoalPlannerNoteRecurrence.NONE) {
                this.isRepeat = true;
                this.selectedDays = this.existingNote.recurring_days || [];
            }
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('close');
        this.clear();
    }
    clear() {
        this.note = new GoalPlannerNote();
        this.isRepeat = false;
        this.selectedDays = [];
        this.editorContent = '';
    }
    submitHandler() {
        if (this.existingNote) {
            this.onUpdateNote();
        }
        else {
            this.onCreateNote();
        }
    }
    omitHtmlTags(input) {
        return input.replace(/<\/?[^>]+(>|$)/g, '');
    }
    getAllowedDates(date) {
        const selectedDate = new Date(date);
        const today = new Date();
        // Set today to start of day for accurate comparison
        today.setHours(0, 0, 0, 0);
        return selectedDate > today;
    }
    // #endregion
    // #region Async methods (api calls only)
    async onCreateNote() {
        try {
            await new GoalPlannerNote().createGroupNote(this.group.id, this.payload);
            this.$emit('note:created');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onUpdateNote() {
        if (!this.existingNote) {
            return;
        }
        try {
            await new GoalPlannerNote().updateGroupNote(this.group.id, this.existingNote.id, this.payload);
            this.$emit('note:updated');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get payload() {
        let payload = {
            start_date: this.existingNote ? this.existingNote.start_date : this.date,
            note: this.omitHtmlTags(this.editorContent),
            recurrence: this.note.recurrence,
        };
        if (this.isRepeat) {
            payload = {
                ...payload,
                recurrence: GoalPlannerNoteRecurrence.WEEKLY,
                recurring_days: this.selectedDays,
            };
            if (this.note.end_date) {
                payload.end_date = this.note.end_date;
            }
        }
        return payload;
    }
    get isValid() {
        if (this.isRepeat) {
            if (!this.note ||
                !this.editorContent ||
                !this.selectedDays ||
                this.selectedDays.length === 0) {
                return false;
            }
        }
        return !!this.note && !!this.editorContent && this.editorContent.trim().length > 0;
    }
    get currentLocale() {
        if (!i18n || !i18n.locale) {
            return 'nl';
        }
        return i18n.locale;
    }
    get editorOptions() {
        return {
            placeholder: this.$t('student_plan.dialog.one.quill'),
        };
    }
    get studentList() {
        return this.group.getStudents();
    }
    get isEditing() {
        return !!this.existingNote;
    }
    get formattedDate() {
        return formattedDate(this.date, 'cccc, dd LLLL yyyy');
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], ManageGoalPlannerNoteDialog.prototype, "date", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], ManageGoalPlannerNoteDialog.prototype, "group", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof GoalPlannerNote !== "undefined" && GoalPlannerNote) === "function" ? _b : Object)
], ManageGoalPlannerNoteDialog.prototype, "existingNote", void 0);
ManageGoalPlannerNoteDialog = __decorate([
    Component({
        components: {
            EditableTextarea,
            AQuillEditor,
        },
    })
], ManageGoalPlannerNoteDialog);
export default ManageGoalPlannerNoteDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
